import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { FormatProductItemProductFragmentDoc } from './FormatProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const ProductItemProductFragmentDoc = gql`
  fragment ProductItemProduct on ProductInterface {
    id
    itemDescription
    brand
    ...FormatProductItemProduct
  }
  ${FormatProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.ProductItemProductFragment, unknown>
